import Vue from 'vue'
import Vuex from 'vuex'
import emailJs from 'emailjs-com'

emailJs.init('user_b68d9UfR8R9t6AMtMJKzX')

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    developerContact: 'https://www.linkedin.com/in/mpwanyi-samuel-402b36108',
    Loading: false
  },
  mutations: {
    setLoading (state, payload) {
      state.Loading = payload
    }
  },
  actions: {
    sendQuote ({ state, commit }, payload) {
      commit('setLoading', true)
      var message = '<p>New Quotation Request From ' + payload.FirstName + ' </p><p>Client Contact: ' + payload.MobileNumber + '</p><p>Installation Type: ' + payload.InstallationType + ' </p><p>Number Of Bathrooms: ' + payload.BirthRooms + '</p><p>Installation Placement: ' + payload.HeaterPlacement + '</p><p>Constant Water Supply: ' + payload.ConstantWaterSupply + '</p><p>Remarks: ' + payload.Remarks + '</p><p>Number Of Users: ' + payload.NumberOfUsers + '</p>'
      var templateparams = {
        'reply_to': payload.Email,
        'from_name': payload.FirstName + ' ' + payload.Lastname,
        'to_name': 'Equator Sun',
        'message_html': message
      }

      var serviceid = 'gmail'
      var templateid = 'template_C4kMAiE8'

      emailJs.send(serviceid, templateid, templateparams).then(function (response) { commit('setLoading', false); alert('Success! Message Sent. We Will Reach You Shortly') })
    },
    sendInquiry ({ state, commit }, payload) {
      commit('setLoading', true)
      var message = '<p>New ' + payload.Inquiry + ' Message From ' + payload.Firstname + ' </p><p>Client Contact: ' + payload.PhoneNumber + '</p><p>Inquiry Type: ' + payload.Inquiry + ' </p><hr><p>Message:<br>' + payload.Remarks + '</p>'

      var templateparams = {
        'reply_to': payload.Email,
        'from_name': payload.Firstname + ' ' + payload.Lastname,
        'to_name': 'EquatorSun',
        'message_html': message
      }
      var serviceid = 'gmail'
      var templateid = 'template_C4kMAiE8'

      emailJs.send(serviceid, templateid, templateparams).then(function (response) { commit('setLoading', false); alert('Success! Message Sent. We will reach you shortlt.') })
    }
  },
  modules: {
  },
  getters: {
    getLoading (state) {
      return state.Loading
    },
    getDeveloper (state) {
      return state.developerContact
    }
  }
})
